import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  title = 'Cinema Issue | VERVE';

  constructor(
    private router: Router
  ) {

  }

  ngOnInit() {
    window.addEventListener('scroll', function () {
      try {
        if (document.getElementById('shareBtn') &&
          document.getElementById('shareBtn').getBoundingClientRect().top < 20) {
          document.getElementsByClassName('nav-bar')[0].classList.add('active');
        } else {
          document.getElementsByClassName('nav-bar')[0].classList.remove('active');
        }
      } catch (e) {
        console.log(e);
      }
    }, true);

    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        try {
          document.getElementsByClassName('nav-bar')[0].classList.remove('active');
        } catch (e) {
          console.log(e);
        }
      }
    });
  }
}
